import { useMemo } from 'react'

import { timeFormats } from '../../../../formats'
import { form } from '../../formState'
import { useTexts } from './hooks/useTexts'

export function TimeFormat() {
  const texts = useTexts()

  const options = useMemo(
    () =>
      Object.entries(timeFormats).map(([value, label]) => ({
        value,
        label,
      })),
    [],
  )

  return (
    <form.RadioGroup
      validateOn="blur change"
      options={options}
      testId="timeFormat"
      label={texts.timeFormat}
      name="timeFormat"
    />
  )
}
